module.exports = __webpack_public_path__ + "img/全面立体的指标中心@2x.ecd77ff0.png";